import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-113f7f86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "variant-grid" }

import { MaterialAndColorVariant } from '@/types/productServerApi';
import SearchResultMaterialVariant
    from '@/shared/product/customizer/ui/overlays/material-and-color/SearchResultMaterialVariant.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResultMaterialVariants',
  props: {
    variants: null
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, { name: "o-anim-fade-300" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.variants, (variant) => {
          return (_openBlock(), _createBlock(SearchResultMaterialVariant, {
            key: variant.sku,
            variant: variant
          }, null, 8, ["variant"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})